import { X } from "lucide-react";
import { CALENDLY_URL } from "@/content";

export default function CalendlyModal({ open, onOpenChange }) {
  if (!open) return null;
  return (
    <div data-testid="calendly-modal" className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" role="dialog" aria-modal="true">
      <div
        className="absolute inset-0 bg-[#0F2018]/85 backdrop-blur-sm"
        onClick={() => onOpenChange(false)}
      />
      <div className="relative w-full sm:max-w-2xl h-[88vh] sm:h-[80vh] bg-[#FBF9F1] rounded-t-3xl sm:rounded-3xl overflow-hidden border border-[#D4AF37]/40 shadow-2xl">
        <div className="flex items-center justify-between px-5 h-14 bg-[#1B3B2B]">
          <div>
            <p className="font-serif text-lg text-[#FBF9F1] leading-tight">Book a Discovery Call</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">
              A relaxed, informational Zoom
            </p>
          </div>
          <button
            data-testid="calendly-modal-close"
            aria-label="Close"
            onClick={() => onOpenChange(false)}
            className="text-[#FBF9F1]/80 hover:text-[#D4AF37] transition-colors p-1"
          >
            <X size={20} />
          </button>
        </div>
        <iframe
          title="Calendly — Book a Discovery Call"
          src={CALENDLY_URL}
          className="w-full h-[calc(100%-3.5rem)] border-0"
        />
      </div>
    </div>
  );
}
